import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { BaseDto } from '@models/base/baseDto.model';
import { CreateEstadoPericiaRequest } from '@models/estadoPericia/createEstadoPericiaRequest.model';
import { UpdateEstadoPericiaRequest } from '@models/estadoPericia/updateEstadoPericiaRequest.model';

@Injectable({
  providedIn: 'root'
})
export class EstadoPericiaService {

  constructor(private http:HttpClient) {
  }

  create(createEstadoPericiRequest:CreateEstadoPericiaRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/EstadoPericia/Create",createEstadoPericiRequest);
  }

  update(updateTipoPeritoRequest:UpdateEstadoPericiaRequest):Observable<any>
  {
    return  this.http.put<any>("/api/EstadoPericia/Update",updateTipoPeritoRequest);
  }

  getAll():Observable<BaseDto[]> {
    return   this.http.get<BaseDto[]>("/api/EstadoPericia/GetAll");
  }

  getById(id:number):Observable<BaseDto>{
    return  this.http.get<BaseDto>("/api/EstadoPericia/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/EstadoPericia/Delete?id=" + id);
    else
      return of(null)
  }

}
